import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Ripple from 'vuetify/lib';
import pt from "vuetify/src/locale/pt";

import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify, {
    directives: Ripple,

});

export default new Vuetify({
    lang: {
      locales: { ptbr: pt },
      current: "ptbr",
    },

    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#333333',
                secondary: '#50514f',
                info: '#70c1b3',
                error: '#f25f5c',
                warning: '#ffe066',
                success: '#4CAF50',

                unavailabletext: "#858786",
                header: "#D8D8D8",
                texto: "#333333",
                fundopagina: "#F4F4F4",
                tituloPainel: "#F4F4F4",
                textoPainelDestaque: "#666666",

                statuspededit: "#AACAEE",
                statuspedaprovado: "#c9e4de",
                statuspedreplicacao: "#EBA36F",
                statuspedaprovacao: "#f7d9c4",
                statuspedcancelado: "#D5D7D6",
                statuspedpendente: "#f7d9c4",
                statuspedromaneio: "#C2F8FF",

                primaryDefault: '#333333',
                headerDefault: "#D8D8D8",
                textoDefault: "#333333",
                painelDestaque: "#F4F4F4",

            },
        }
    }
});
